import React from 'react';
import { Target, Compass, Lightbulb, Award } from 'lucide-react';
import { aboutContent } from '../mockData';

const About = () => {
  const sections = [
    {
      icon: <Compass size={28} />,
      title: "Our Story",
      content: aboutContent.story
    },
    {
      icon: <Target size={28} />,
      title: "Mission",
      content: aboutContent.mission
    },
    {
      icon: <Lightbulb size={28} />,
      title: "Vision",
      content: aboutContent.vision
    },
    {
      icon: <Award size={28} />,
      title: "Approach",
      content: aboutContent.approach
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <div className="stars-container">
            {[...Array(30)].map((_, i) => (
              <div
                key={i}
                className="star"
                style={{
                  left: `${Math.random() * 100}%`,
                  top: `${Math.random() * 100}%`,
                  animationDelay: `${Math.random() * 3}s`
                }}
              />
            ))}
          </div>
        </div>

        <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-light mb-6 tracking-tight">
            About NRFSTR
          </h1>
          <p className="text-xl text-white/60 leading-relaxed">
            We're on a mission to build innovative products that empower creators and transform the way people work.
          </p>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            {sections.map((section, index) => (
              <div
                key={index}
                className="group bg-gradient-to-br from-white/5 to-white/[0.02] rounded-3xl p-8 border border-white/10 hover:border-white/20 transition-all duration-500"
              >
                <div className="flex items-center space-x-4 mb-6">
                  <div className="flex items-center justify-center w-14 h-14 rounded-2xl bg-white/5 text-white/80 group-hover:bg-white/10 group-hover:text-white transition-all duration-300">
                    {section.icon}
                  </div>
                  <h2 className="text-2xl font-medium">{section.title}</h2>
                </div>
                <p className="text-white/70 leading-relaxed">
                  {section.content}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy Section */}
      <section className="py-32 border-t border-white/10">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-light mb-8">
            Built with Purpose
          </h2>
          <p className="text-white/70 text-lg leading-relaxed mb-12">
            At NRFSTR, every line of code, every design decision, and every feature is crafted with intention. We believe that great software should be invisible—it should just work, beautifully and effortlessly.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-16">
            {[
              { label: "Quality", value: "Uncompromising" },
              { label: "Design", value: "Thoughtful" },
              { label: "Impact", value: "Meaningful" }
            ].map((item, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl md:text-4xl font-light mb-2">{item.value}</div>
                <div className="text-white/50 text-sm uppercase tracking-wider">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
